import { render, staticRenderFns } from "./activityNBAextended.html?vue&type=template&id=32e95b24&external"
import script from "./activityNBAextended.vue?vue&type=script&lang=js"
export * from "./activityNBAextended.vue?vue&type=script&lang=js"
import style0 from "./activityNBAextended.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports